export default __webpack_public_path__ + "static/essentialGuide-2f0f36702c6a05ecea31ab4bc2a9fef0.jpeg";